module.exports = new __parcel__URL__("machines_laser_cannon_level_2.0f7543c9.png").toString();